import React from 'react';
import classNames from "classnames";
import './homeServiceCard.scss';
function HomeServiceCard(props) {
    var _a;
    var label = props.label, _b = props.headerClassName, headerClassName = _b === void 0 ? '' : _b, image = props.image, text = props.text;
    var header = classNames((_a = {
            'relative w-full pb-1/2 rounded-t-md': true
        },
        _a[headerClassName] = headerClassName,
        _a));
    return (React.createElement("div", { className: 'relative flex flex-col w-full h-full bg-white shadow-xl hover:shadow-md hover:-translate-y-1 rounded-md transform transition-all duration-200 ease-in-out' },
        React.createElement("div", { className: header },
            image ? image : null,
            React.createElement("div", { className: 'absolute left-3 top-4 font-bold text-16 sm:text-18 leading-4 text-left' }, label)),
        React.createElement("div", { className: 'px-5 py-3' },
            React.createElement("p", { className: 'text-14 font-normal text-justify' }, text))));
}
export default HomeServiceCard;
